export default ({ role = 'admin' } = {}) => {
  const publicUrlMeta = document.querySelector('meta[name="centrifugo-public-url"]');
  const tokenMeta = document.querySelector('meta[name="centrifugo-connection-token"]');

  if (publicUrlMeta && tokenMeta) {
    const publicUrl = publicUrlMeta.getAttribute('content');
    const token = tokenMeta.getAttribute('content');

    return {
      socketConnectionToken: token,
      socketConnectionUrl: publicUrl,
      subscriptionEndpoint: `${window.location.protocol}//${window.location.host}/api/${role}/websockets/subscribe`,
    };
  }
};
